<!-- 我要提问 -->
<template>
    <div>
      <div class="course_putQuestions">
        <el-row>
          <el-input v-model="searchInfo.stukey" style="width: 200px;" prefix-icon="el-icon-search" placeholder="学生问题检索"></el-input>
          <el-input v-model="searchInfo.teakey" style="width: 200px;" prefix-icon="el-icon-search" placeholder="教师问题检索"></el-input>
          <label style="margin-left: 20px;">状态：</label>
          <el-select clearable v-model="searchInfo.replyStatus" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo">查询</el-button>
          <!-- <el-button type="success" icon="el-icon-s-promotion" @click="showQuestions">发起提问</el-button> -->
        </el-row>
        <p class="mb10 mt10 font14">关键字：
          <template v-for="(item,index) in keyList">
            <el-link v-if="!$isEmpty(item)" :type="onKey == item?'danger':'primary'" :underline="false" class="mr10" @click="seeKey(item)">{{item}}</el-link>
          </template>
        </p>
        <el-row class="content_block mt10">
          <el-row>
            <el-table
              :data="tableData"
              border
              ref="refTable"
              style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <template v-if="!$isEmpty(props.row.children) && props.row.children.length > 0">
                    <el-row style="padding: 10px 10px 0 10px;" v-for="(it,index) in props.row.children" :key="index+'_'" v-html="'回复内容：'+it.chatContent">
                    </el-row>
                  </template>
                  <template v-else>
                    <span style="margin-left: 20px;">暂无回复</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="studentIdText" header-align="center" align="center" label="学生姓名" width="150"> </el-table-column>
              <el-table-column prop="chatContent" header-align="center" align="left" label="问题">
                <template slot-scope="scope">
                  <el-row v-html="scope.row.chatContent"></el-row>
                </template>
              </el-table-column>
              <el-table-column prop="keywords" header-align="center" align="center" label="关键词" width="200">
                <template slot-scope="scope">{{$isEmpty(scope.row.keywords)?'-':scope.row.keywords}}</template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseChatLogAddTime" header-align="center" align="center" label="提问时间" width="200"> </el-table-column>
              <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="showQuestions(scope.row,scope.$index)">回复</el-link>
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="lookReply(scope.row,scope.$index)">查看回复</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="false"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 提问对话框 -->
        <el-dialog
          title="我要回答"
          :visible.sync="user_questions_show"
          width="800px"
        >
          <el-row class="mb40">
            <el-col :span="3">问题摘要：</el-col>
            <el-col :span="21" class="user_questions">
              <el-row v-html="questionsInfo.chatContent"></el-row>
            </el-col>
          </el-row>
          <el-row class="mb40">
            <RichText ref="richText" v-if="user_questions_show" v-model="questionsInfo.forest_desc" />
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="user_questions_show = false">取 消</el-button>
            <el-button type="primary" @click="submitInfo">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import RichText from '@/components/RichText/index';

export default {
  name: 'PutQuestions',
  components: {
    RichText
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      options: [
      {
        value: '',
        label: '全部'
      },{
        value: '1',
        label: '待回答'
      }, {
        value: '2',
        label: '已回答'
      }],
      value: '',
      searchInfo:{
        teakey:"",
        stukey:"",
        replyStatus:"",
      },
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      user_questions_show:false,
      questionsInfo:{},
      onKey:"",
      keyList:[]
    }
  },
  created() {
    this.getInfo();
    this.getKeywordsList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      this.tableData = [];
      let param = {
        teakey:this.searchInfo.teakey,
        chatContent:this.searchInfo.teakey || this.searchInfo.stukey,
        replyStatus:this.searchInfo.replyStatus,
        keywords:this.onKey,
        limit:this.limit,
        page:this.page,
        chatLogSendType:"student_ask",
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseChatLog/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          let data = ret.data;
          this.tableData = data;
          if(data.length>0&&!this.$isEmpty(data)){
            for(let i=0;i<data.length;i++){
              let childParam = {
                teacherOpenCourseId:this.courseId,
                // teacherId
                teacherOpenCourseChatLogParentId:data[i].teacherOpenCourseChatLogId
              }
              this.$post("/api/teacherOpenCourseChatLog/getPageList.do",childParam).then((res)=>{
                if(res.code == 0&&res.data.length>0&&!this.$isEmpty(res.data)){
                  this.tableData[i].children= res.data;
                }else{
                  this.tableData[i].children = [];
                }
              });
            }
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getKeywordsList(){ //获取关键字数据
      let param = {
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseChatLog/getKeywordsList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.keyList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    lookReply(item,i){ //查看回复
      let param = {
        teacherOpenCourseId:this.courseId,
        // teacherId
        teacherOpenCourseChatLogParentId:item.teacherOpenCourseChatLogId
      }
      this.$post("/api/teacherOpenCourseChatLog/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.tableData[i].children = ret.data;
          // this.tableData[i].children = [{chatContent:"你好呀"},{chatContent:"你好呀"}];
          this.$nextTick(()=>{
            this.$refs.refTable.toggleRowExpansion(item) // 点击button展开
          })
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    seeKey(key){ //点击选择关键字 快速搜索
      if(key == this.onKey){
        this.onKey = "";
      }else{
        this.onKey = key;
      }
      this.getInfo();
    },
    showQuestions(item){
      this.questionsInfo = item;
      this.user_questions_show = true;
      this.questionsInfo.forest_desc = "";
    },
    submitInfo(){ //打开提问对话框
      if(this.$isEmpty(this.questionsInfo.forest_desc)){
        this.$message({message: '请输入回答内容！',type: 'warning'});
        return;
      }
      let param = {
        teacherOpenCourseId:this.courseId,
        chatContent:this.questionsInfo.forest_desc,
        chatLogSendType:"normal",
        teacherOpenCourseChatLogParentId:this.questionsInfo.teacherOpenCourseChatLogId,
      }
      this.$postJSON("/api/teacherOpenCourseChatLog/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.user_questions_show = false;
          this.$message({message: '提交成功！',type: 'success'});
          this.$emit("onSuccess_s");
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_putQuestions{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
    .el-dialog__footer{
      padding-top: 20px;
    }
    .el-form-item{
      margin-bottom: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/interaction/PutQuestions.vue